import UserLocationModal from './UserLocationModal.vue';

export default {
    UserLocationModal,
};
